module.exports = __webpack_public_path__ + "media/gun_3.98bb9f97.webm";